import type { OptionValue } from '@tempmee/core';

export const OFFICE_TYPE_OPTIONS: OptionValue<string>[] = [
  { label: 'Private Practice (Independent)', value: 'private_practice_independent' },
  { label: 'Private Practice (Multi-Location)', value: 'private_practice_multi' },
  { label: 'DSO', value: 'dso' },
];
